import React, { useState, useEffect } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import SearchIcon from "../../assets/images/icons/search-icon.webp";
import { BiSearch } from "react-icons/bi";
import { casinoSection } from "../../lib/data/casinoSection.data";
import { auraGames } from "../../lib/data/auraGames.data";
import { SlotGames } from "../../lib/data/SlotGames.data";
import { KingmakerGames } from "../../lib/data/KingmakerGames.data";
import { QtechGames } from "../../lib/data/QtechGames.data";
import { EvolutionGames } from "../../lib/data/evolutiongames.data";
import { altGaming } from "../../lib/data/altGaming.data";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);

  const totalGames = {
    ...casinoSection?.popularGames,
    ...casinoSection?.AndarBahar,
    ...casinoSection?.roulettetab,
    ...casinoSection?.dragontiger,
    ...casinoSection?.baccarattab,
    ...casinoSection?.blackjacktab,
    ...casinoSection?.pokertab,
    ...casinoSection?.supernowa,
    ...casinoSection?.instantGames,

    ...auraGames?.improvedExperience,
    ...auraGames?.cardGames,
    ...auraGames?.virtualCardGames,
    ...auraGames?.instantGames,
    ...SlotGames?.netenttab,
    ...SlotGames?.redtigertab,
    ...KingmakerGames?.kingmaker,
    ...QtechGames?.turbo,
    ...QtechGames?.hacksaw,
    ...EvolutionGames,
    ...altGaming?.jiliGaming,
    ...altGaming?.mac88Gaming,
    ...QtechGames?.colorgame,
  };

  useEffect(() => {
    return () => {
      setFilteredData(null);
    };
  }, []);

  const handleClose = () => {
    setFilteredData(null);
    setShow(false);
  };
  const handleSearch = (e) => {
    if (e) {
      let filteredValue = Object.values(totalGames)?.filter((item) => {
        return (
          item?.name && item.name.toLowerCase().indexOf(e?.toLowerCase()) > -1
        );
      });
      setFilteredData(filteredValue);
    }
  };

  return (
    <>
      <div className="search-box">
        <div className="searchGames" onClick={handleShow}>
          <img src={SearchIcon} alt="search" />
          {/* <BiSearch /> */}
          <p>Search...</p>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} className="search-modal">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Search Games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search your favourite games here..."
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>

          <ul className="gamelisting">
            {filteredData &&
              filteredData.map((item) => (
                <li>
                  <a href={item.redirectUrl}>
                    <img src={item.imgUrl} />
                    <div className="providerName">{item.providerName}</div>
                    <div className="GameName">{item.name}</div>
                  </a>
                </li>
              ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
